import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionTypeEnum } from '@/models/Question';
import { CombinationCue } from '@/components/question/view/primitives/standard/CombinationCue';
import { CombinationResultCard } from '@/components/question/view/primitives/correction/CombinationResultCard';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { useCombinationCorrection } from '@/components/question/view/typologies/combination/useCombinationCorrection';

export function CombinationCorrectionView(
  props: QuestionViewPropsFor<QuestionTypeEnum.DND_POSITIONAL>,
) {
  const { entries } = useCombinationCorrection(props);
  const { t } = useTranslation('translation', { keyPrefix: 'questionView' });

  return (
    <div className="grid w-full grid-cols-[fit-content(40%)_1fr] items-center gap-4">
      {entries.map(entry => (
        <Fragment key={entry.id}>
          <CombinationCue cue={entry.cue} />
          <CombinationResultCard entry={entry} label={t('studentAnswer')} />
        </Fragment>
      ))}
    </div>
  );
}
